<h2 mat-dialog-title>Send ny invitation</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>
<form [formGroup]="sendSmsFormGroup">
  <mat-dialog-content>
    <div class="flex form-row flex-col">
      <ok-feedback-info>
        <div>
          <b>Bemærk</b>
          <br />
          <p>
            Nedenstående mobilnummer er hentet fra
            <strong>{{ data.chargingUser.name }}</strong>
            nuværende brugerdata
          </p>
        </div>
      </ok-feedback-info>
    </div>
    <div class="form-row sms-send-form">
      <div class="grid-cols">
        <adm-country-code-selector [formItem]="sendSmsFormGroup.controls.countryCode" />
        <adm-phone-number-input
          [label]="'Mobilnummer'"
          [formItem]="sendSmsFormGroup.controls.phoneNumber"
          [hintText]="'Der sendes en sms til dette mobilnummer med et link til OK-appen'"
          [countryCode]="sendSmsFormGroup.controls.countryCode" />
      </div>
    </div>
    <div class="form-row">
      <mat-slide-toggle formControlName="sendSmsLater" color="primary" class="form-row sms-send-form">
        <div class="flex flex-col">Planlæg afsendelse</div>
      </mat-slide-toggle>
    </div>
    @if (this.sendSmsFormGroup.controls.sendSmsLater.value) {
      <adm-date-with-time-selector class="form-row" [formItem]="sendSmsFormGroup.controls.smsSendDate"></adm-date-with-time-selector>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>Annuller</button>
    <button
      type="submit"
      [class.loading]="sending$ | async"
      [class.loading--dark]="sending$ | async"
      mat-flat-button
      color="primary"
      (click)="sendSms()"
      [disabled]="sendSmsFormGroup.invalid || (sending$ | async)">
      Send
    </button>
  </mat-dialog-actions>
</form>
